import { Input } from '@/components/ui/input.js';
import { cn } from '@/lib/utils.js';

interface DateParamProps {
  id: string;
  value: string;
  onChange: (iso: string) => void;
  disabled?: boolean | undefined;
  error?: string | undefined;
  required?: boolean | undefined;
}

export function DateParam({ id, value, onChange, disabled, error, required }: DateParamProps) {
  return (
    <>
      <Input
        id={id}
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        error={error !== undefined}
        required={required}
        aria-required={required === true ? true : undefined}
        aria-describedby={error !== undefined ? `${id}-error` : undefined}
        className={cn('w-full')}
      />
      {error !== undefined && (
        <span
          id={`${id}-error`}
          role="alert"
          className="mt-1 block text-xs text-[var(--color-qup-error)]"
        >
          {error}
        </span>
      )}
    </>
  );
}
